import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './Pis.css';
import { fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import * as actions from '../Actions';
import withContext from "../../../withContext";

const service = new Service();

class PisManageReminder extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let reminderData = [];
        this.reminderStatusAll = 0;
        this.reminderStatusCurrent = 0;
        
        // console.log('params >>>', props.params)
        // this.testId = props.match.params.id ? props.match.params.id : '';
        this.testId = props?.params?.id || '';


        let _this = this;
        this.editReminderIndex = -1;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData) {
            if (serverSideData['data1'] && serverSideData['data1']['result']) {
                initialData = serverSideData['data1']['result']['test'].filter(function (item) {
                    return _this.testId == item.id;
                });
            }
            if (serverSideData['data2'] && serverSideData['data2']['result']) {
                reminderData = serverSideData['data2']['result'];
                this.reminderStatusAll = serverSideData['data2']['allTestRemiderStatus'];
                this.reminderStatusCurrent = serverSideData['data2']['remiderStatus'];
            }
        }
        console.log("serverSideData -----",serverSideData)
        this.state = {
            initialData: initialData,
            reminderData: reminderData,
            isShowReminderCheck: false,
            isDisableReminderCurrent: this.reminderStatusCurrent == 1 ? true : false,
            isDisableReminderAll: this.reminderStatusAll == 1 ? true : false,
            disablePopupFor: '',
            infoPopupFor: '',
            minReminderDate: '',
            maxReminderDate: '',
            saveReminderIndx: '',
            metaTitle: "Pregnancy Checkup Schedule – Tests, Screening, Scans & more",
            metaDescription: [
                { "name": "description", "content": "Prenatal medical care is most important to monitor the health of pregnant woman and baby. Find more about checkups to be done during pregnancy for a healthy baby & You. Get more information about antenatal care at FirstCry Parenting." },
                { "name": "keywords", "content": "prenatal care, pregnancy checkup, medical examination during pregnancy" },
                { "name": "atdlayout", "content": "tools_sp" }
            ]
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let obj1 = {
            url: global.api_url + "preginspection/getpregnancyinspectiontest",
            body: JSON.stringify({})
        };
        let obj2 = {
            url: global.api_url + "preginspection/getreminderdetails",
            body: JSON.stringify({
                testid: reqUrl.split('/')[reqUrl.split('/').length - 2]
            })
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {
        console.log(this.state.initialData);
        console.log(this.state.reminderData);
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.pisData();
            } else {
                localStorage.setItem('pisDataReport' + this.testId, JSON.stringify(this.state.initialData));
                this.setDateRange();
            }
            if (!this.state.reminderData || (this.state.reminderData && Object.keys(this.state.reminderData).length < 1)) {
                service.showLoader();
                this.pisReminderData();
            } else {
                localStorage.setItem('pisDataReminder' + this.testId, JSON.stringify(this.state.reminderData));
            }
        } else {
            if (localStorage.getItem('pisDataReport' + this.testId)) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('pisDataReport' + this.testId)) }, () => { this.setDateRange(); });
            }
            if (localStorage.getItem('pisDataReminder' + this.testId)) {
                this.setState({ reminderData: JSON.parse(localStorage.getItem('pisDataReminder' + this.testId)) });
            }
            service.hideLoader();
        }
    }

    pisData() {
        var postData = {};
        var url = global.api_ci_url + "Pis/getPisLandingData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                let _this = this;
                let initialData = json['result']['test'].filter(function (item) {
                    return _this.testId == item.id;
                });
                this.setState({ initialData: initialData }, () => { this.setDateRange(); });
                localStorage.setItem('pisDataReport' + this.testId, JSON.stringify(initialData));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    pisReminderData() {
        var postData = {
            testid: this.testId
        }
        var url = global.api_ci_url + "Pis/getPisReminderData";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                this.setState({ reminderData: json['result'] });
                localStorage.setItem('pisDataReminder' + this.testId, JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    changeReminderState() {
        let state = this.state.isShowReminderCheck;
        this.setState({ isShowReminderCheck: !state });
    }

    disableReminder(key, popupForVal) {
        if (key == 'all') {
            let state = this.state.isDisableReminderAll;
            if (popupForVal == '') {
                this.setState({ isDisableReminderAll: this.reminderStatusAll, isDisableReminderCurrent: this.reminderStatusCurrent, disablePopupFor: popupForVal });
            } else {
                this.setState({ isDisableReminderAll: !state, isDisableReminderCurrent: !state, disablePopupFor: popupForVal });
            }
        } else {
            let state = this.state.isDisableReminderCurrent;
            this.setState({ isDisableReminderCurrent: !state, disablePopupFor: popupForVal });
        }
    }

    updateReminderStatus() {
        var postData = {}
        var url = "";
        var status = "0";
        if (this.state.disablePopupFor == 'all') {
            if (this.state.isDisableReminderAll) {
                status = "1";
            }
            postData = {
                status: status
            };
            url = global.api_ci_url + "Pis/updateReminderStatusAllTest"
        } else {
            if (this.state.isDisableReminderCurrent) {
                status = "1";
            }
            postData = {
                status: status,
                testid: this.testId
            };
            url = global.api_ci_url + "Pis/updateReminderStatusTest"
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.disablePopupFor == 'all') {
                    this.reminderStatusAll = parseInt(postData['status']);
                    this.reminderStatusCurrent = parseInt(postData['status']);
                } else {
                    this.reminderStatusCurrent = parseInt(postData['status']);
                }
                this.setState({ disablePopupFor: '' });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    addReminder() {
        if (this.state.isDisableReminderCurrent) {
            this.setState({ infoPopupFor: 'enableReminder' });
        } else {
            if (this.state.reminderData && this.state.reminderData.length < 4) {
                let type = 3;
                let reminderAry = this.state.reminderData;
                reminderAry.push({ date: new Date().toString(), type: type, isNew: true, isEdit: true });
                if (this.editReminderIndex >= 0) {
                    reminderAry = this.removeEditReminder(reminderAry, this.editReminderIndex);
                }
                this.editReminderIndex = type;
                this.setState({ reminderData: reminderAry });
            } else {
                this.setState({ infoPopupFor: 'maxReminder' });
            }
        }
    }

    editReminder(index) {
        if (this.state.isDisableReminderCurrent) {
            this.setState({ infoPopupFor: 'enableReminder' });
        } else {
            let reminderAry = this.state.reminderData;
            reminderAry[index]['isEdit'] = true;
            if (this.editReminderIndex >= 0) {
                reminderAry = this.removeEditReminder(reminderAry, this.editReminderIndex);
            }
            this.editReminderIndex = index;
            this.setState({ reminderData: reminderAry });
        }
    }

    cancleEditReminder(index) {
        if (actions.getDateStringPis(this.state.reminderData[index]['date']) == document.getElementById('testDate_' + index).value && actions.getTimeValPis(this.state.reminderData[index]['date']) == document.getElementById('testTime_' + index).value) {
            console.log("1");
            this.clearEditReminder(index);
        } else {
            console.log("2")
            this.setState({ saveReminderIndx: index });
        }
    }

    clearEditReminder(index) {
        if (this.editReminderIndex == index) {
            this.editReminderIndex = -1;
        }
        let reminderAry = this.state.reminderData;
        reminderAry = this.removeEditReminder(reminderAry, index);
        this.setState({ reminderData: reminderAry, saveReminderIndx: '' });
    }

    removeEditReminder(reminderAry, index) {
        if (reminderAry[index]['isNew']) {
            reminderAry.splice(index, 1);
        } else {
            delete reminderAry[index]['isEdit'];
        }
        return reminderAry;
    }

    setMinDate() {
        let cDate = new Date();
        let year = cDate.getFullYear();
        let month = cDate.getMonth() + 1;
        let day = cDate.getDate();
        month = month > 9 ? month : "0" + month;
        day = day > 9 ? day : "0" + day;
        let minDate = year + '-' + month + '-' + day;
        return minDate;
    }

    setMaxDate() {
        let date = this.state.initialData[0]['dueOn'];
        let cDate = new Date(date.replace(/-/g, '/'));
        let year = cDate.getFullYear();
        let month = cDate.getMonth() + 1;
        let day = cDate.getDate();
        month = month > 9 ? month : "0" + month;
        day = day > 9 ? day : "0" + day;
        let maxDate = '';
        if (this.state.initialData[0]['status'] == 'upcoming') {
            maxDate = year + '-' + month + '-' + day;
        }
        return maxDate;
    }

    setDateRange() {
        this.setState({ minReminderDate: this.setMinDate() });
        this.setState({ maxReminderDate: this.setMaxDate() });
    }

    saveReminder(index) {
        if (this.state.isDisableReminderCurrent) {
            this.setState({ infoPopupFor: 'enableReminder' });
        } else {
            var date = document.getElementById('testDate_' + index).value + " " + document.getElementById('testTime_' + index).value
            var postData = {
                testid: this.testId,
                type: index.toString(),
                date: date
            };
            var url = global.api_ci_url + "Pis/setReminder"
            service.postServiceCall(url, postData).then((json) => {
                console.log(json);
                if (json['msg'] == "1") {
                    let reminderAry = this.state.reminderData;
                    reminderAry[index]['date'] = date;
                    if (reminderAry[index]['isNew']) {
                        delete reminderAry[index]['isNew'];
                    }
                    this.setState({ reminderData: reminderAry }, () => { this.clearEditReminder(index); });
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }
    }

    render() {
        return (
            <main className="main-container pis-main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools/pregnancy-checkup-schedule")} className="R11_9e">Pregnancy Inspection Schedule</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        {this.state.initialData && this.state.initialData[0] && this.state.initialData[0]['title'] ?
                            <span><a href={service.getRedirectUrl(`/tools/pregnancy-checkup-schedule/manageReports/${this.state.initialData[0]['title'].trim().replace(/\s/g, "_").replace(/\//g, "+")}/${this.testId}`)} className="R11_9e">Manage Reports</a></span>
                            :
                            <span>Manage Reports</span>
                        }
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Manage Reminders</span>
                    </div>
                    {this.state.initialData && this.state.initialData[0] && this.state.initialData[0]['title'] &&
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.state.initialData[0]['title'] + " - Manage Reminder"}</h1>
                    }
                </div>
                <div className="sub-container left pis_details_sub_conterner_remainder_360">
                    <div className="data-container left">
                        <div className="manage-reminder">
                            {this.state.initialData && this.state.initialData[0] &&
                                <div className="mng_rem_top">
                                    <p className="mng_rem_text">
                                        <span className="mng_rem_ic" data-icon-font="" style={this.state.initialData[0]['status'] == 'overdue' ? { color: "#e8514e" } : {}}></span>
                                        {this.state.initialData[0]['title'] &&
                                            <span className="mng_rem_vc_nam M14_42">{this.state.initialData[0]['title'] + " "}</span>
                                        }
                                        {this.state.initialData[0]['endWeek'] &&
                                            <span className="mng_rem_dose R12_75">({actions.getPragnancyTrimesterText(this.state.initialData[0]['endWeek'])})</span>
                                        }
                                    </p>
                                </div>
                            }
                            {this.state.reminderData && this.state.reminderData.length > 0 && this.state.reminderData.map((reminder, index) =>
                                <div key={index} className={(index + 1) == this.state.reminderData.length ? "rem_count_mn rem_count_mn_last" : "rem_count_mn"}>
                                    <span className="M14_42">
                                        <i className="mng_rem_ic icon" data-icon-font="%"></i>
                                        <span>{index + 1}{(index + 1) == 1 ? "st" : ((index + 1) == 2 ? "nd" : ((index + 1) == 3 ? "rd" : "th"))} Reminder</span>
                                    </span>
                                    {reminder.isEdit ?
                                        <div className="set_rem rep">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className="rm_tb_titl R13_9e">Select Date*</td>
                                                        <td className="rm_tb_titl R13_9e">Select Time</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input id={`testDate_${index}`} type="text" className="rm_inp R14_42" defaultValue={actions.getDateStringPis(reminder.date)} readOnly onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} onBlur={(e) => service.onBlurDate(e)} min={this.state.minReminderDate} max={this.state.maxReminderDate} />
                                                            <span className="icon calender" data-icon-font="w"></span>
                                                        </td>
                                                        <td>
                                                            <input id={`testTime_${index}`} type="time" className="rm_inp tm_inp R14_42" defaultValue={actions.getTimeValPis(reminder.date)} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div className="rem_sav">
                                                                <span className="B14_white dev_saveReminder" onClick={() => this.saveReminder(index)}>SAVE</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="rem_can" onClick={() => this.cancleEditReminder(index)}>
                                                                <span className="B14_white">CANCEL</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        :
                                        <div className="reminder-date M15_fc88af">
                                            <span>{actions.getDateStringPis(reminder.date) + "@ " + actions.getTimeStringPis(reminder.date)}</span>
                                            <span data-icon-font="H" className="edit edit_reminder icon" onClick={() => this.editReminder(index)}></span>
                                        </div>
                                    }
                                </div>
                            )}
                            <div className="add_rem" onClick={() => this.addReminder()}>
                                <span className="B14_white">ADD CUSTOM REMINDER</span>
                            </div>
                            <div className="mng_rem">
                                <div id="manage-reminders" onClick={() => this.changeReminderState()}>Manage Reminders</div>
                                {this.state.isShowReminderCheck &&
                                    <div className="chek_mng">
                                        <div className="dis-enbl">
                                            <span onClick={() => this.disableReminder('current', 'current')}>
                                                {this.state.isDisableReminderCurrent ?
                                                    <span className="icon isChecked" data-icon-font="A"></span>
                                                    :
                                                    <span className="icon" data-icon-font="z"></span>
                                                }
                                                <span className="mng_rem_txt">Disable Reminders for this Test</span>
                                            </span>
                                        </div>
                                        <div className="dis-enbl">
                                            <span onClick={() => this.disableReminder('all', 'all')}>
                                                {this.state.isDisableReminderAll ?
                                                    <span className="icon isChecked" data-icon-font="A"></span>
                                                    :
                                                    <span className="icon" data-icon-font="z"></span>
                                                }
                                                <sapn className="mng_rem_txt">Disable Reminders for all Test</sapn>
                                            </span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.disablePopupFor != '' &&
                    <div className="gr_main_overlay_reminder">
                        <div className="growth_main_reminder">
                            <div className="gr_fields_reminder">
                                {this.state.disablePopupFor == 'current' &&
                                    <div className="R15_42">{this.state.isDisableReminderCurrent ? "All the reminders for this test would be disabled, do you want to continue?" : "All the reminder notifications for this test would be enabled, do you want to continue?"}</div>
                                }
                                {this.state.disablePopupFor == 'all' &&
                                    <div className="R15_42">{this.state.isDisableReminderAll ? "Reminders for all the test would be disabled, do you want to continue?" : "Reminder notifications for all the test would be enabled, do you want to continue?"}</div>
                                }
                            </div>
                            <div className="gr_btns">
                                <div className="gr_can">
                                    <span className="M15_75" onClick={() => this.disableReminder(this.state.disablePopupFor, '')}>CANCEL</span>
                                </div>
                                <div className="gr_sav">
                                    <span className="M15_fc88af" onClick={() => this.updateReminderStatus()}>OK</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.infoPopupFor != '' &&
                    <div className="gr_main_overlay_reminder">
                        <div className="growth_main_reminder">
                            <div className="gr_fields_reminder">
                                {this.state.infoPopupFor == 'enableReminder' &&
                                    <div className="R15_42">Please enable reminders to proceed further.</div>
                                }
                                {this.state.infoPopupFor == 'maxReminder' &&
                                    <div className="R15_42">You can add only 4 reminders.</div>
                                }
                            </div>
                            <div className="gr_btns">
                                {/* <div className="gr_can">
                                    <span className="M15_75">CANCEL</span>
                                </div> */}
                                <div className="gr_sav">
                                    <span className="M15_fc88af" onClick={() => { this.setState({ infoPopupFor: '' }) }}>OK</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.saveReminderIndx != '' &&
                    <div className="gr_main_overlay_reminder">
                        <div className="growth_main_reminder">
                            <div className="gr_fields_reminder">
                                <div className="R15_42">Do you want to save changes ?</div>
                            </div>
                            <div className="gr_btns">
                                <div className="gr_can">
                                    <span className="M15_75" onClick={() => this.clearEditReminder(this.state.saveReminderIndx)}>NO</span>
                                </div>
                                <div className="gr_sav">
                                    <span className="M15_fc88af" onClick={() => this.saveReminder(this.state.saveReminderIndx)}>YES</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <Right url={this.props.location.pathname} />
            </main >
        )
    }
}

export default withContext(PisManageReminder);
